import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPriceCurrency, getCurrency } from 'utils/utils';
import Checkbox from 'components/ui/Checkbox/Checkbox';
import { DealModel, PckRoom } from 'ts/package/interfaces/PackageOfflineResponse';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { getBoardName } from 'utils/package';

interface RoomsDetailsProps {
  dealModel: DealModel;
  onChangeRoom: (room: PckRoom, uKey: string) => void;
  selectedRoomKey: string;
}

const RoomsDetails: FC<RoomsDetailsProps> = ({ dealModel, onChangeRoom, ...props }) => {
  const { t } = useTranslation();
  return (
    <div className="hotel-card-rooms details-rooms mb-10">
      <div className="hotel-card-room room-header">
        <div className="pr-5"> #</div>
        <div className="ph-10 flex-one">{t('hotel.rooms_price')}</div>
        <div className="ph-10">{t('hotel.room_type')}</div>
        <div className="ph-10">{t('hotel.boarding')}</div>
        <div className="ph-10">{t('hotel.desc')}</div>
        <div className="pl-10">{t('price')}</div>
      </div>

      {dealModel.package.oneItemPrice.listOfpckRoomTypeList?.[0]?.pckRooms?.map((room, index) => {
        return (
          <div className="hotel-card-room details-card-room" key={index}>
            <div className="pr-5">
              <Checkbox
                onChange={() => onChangeRoom(room, room.uKey)}
                checked={room.uKey === props.selectedRoomKey}
              />
            </div>
            <div className="ph-10 flex-one">{room.room.desc}</div>
            <div className="ph-10 text-sm">{room.class.name}</div>
            <div className="ph-10 text-sm">{getBoardName(room.board.name)}</div>
            <div className="ph-10 text-sm">{room.desc}</div>
            <div className="pl-10 text-bold text-contrast">
              {formatPriceCurrency(room.room.bruto, getCurrency(dealModel.currency))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default withErrorBoundary(RoomsDetails, 'RoomsDetails');
